import CompanyCollectionsAdd from './CompanyCollectionsAdd';

export default CompanyCollectionsAdd;
